import * as React from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';

export default function StepperComp(props) {
  return (
    <Box sx={{ width: '100%' }}>
      <Stepper activeStep={props.active} alternativeLabel>
        {props.steps.map((label) => (
          <Step key={label}>
            <StepLabel sx={{fontSize:'12px'}}>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
}